import React, { useState } from "react";
import { makeStyles } from "@mui/styles";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Card from "components/Card/Card";
import GEBRTEquipments from "./GEBEquipments/RTEquipments";
import DashboardRTEquipments from "./DashboardEquipments/RTEquipments";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "0 0 5px 5px",
    boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
    textTransform: "none",
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
  tabPanel: {
    padding: "0",
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>{children}</>

      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}


export default function EquipmentsVT(props) {
  const classes = useStyles();
  const currentusertype = localStorage.getItem('userType');
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_admin = permis.includes("mbm_geb_admin");
  const [value, setValue] = useState(0);
  const { currentWorkspace, equipments, fullpoints } = props;
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };


  return (

    <GridItem xs={12} sm={12} md={12} lg={12}>
      <Card style={{ marginTop: '20px', paddingTop: '10px' }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={2} lg={2}>
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={value}
              onChange={handleTabChange}
              aria-label="Vertical tabs example"
              className={classes.tabs}
              TabIndicatorProps={{ style: { background: "#91C73C" } }}
            >

              <Tab className={classes.tab} label="Equipements" {...a11yProps(0)} />
              {mbm_geb_admin ?
                <Tab className={classes.tab} label="Intégration GEB" {...a11yProps(1)} /> : <></>}
            </Tabs>
          </GridItem>
          <GridItem xs={12} sm={12} md={10} lg={10}>

            <TabPanel value={value} index={0} className={classes.tabPanel} >
              <DashboardRTEquipments wpgroup={currentWorkspace.idgroup} workspace={currentWorkspace} />
            </TabPanel>
            <TabPanel value={value} index={1} className={classes.tabPanel} >
              <GEBRTEquipments wpgroup={currentWorkspace.idgroup} workspace={currentWorkspace} />
            </TabPanel>
            {/* <TabPanel value={value} index={2} className={classes.tabPanel} >
           
           </TabPanel>
           <TabPanel value={value} index={3} className={classes.tabPanel} >
           
           </TabPanel> */}
          </GridItem>
        </GridContainer>
      </Card>
    </GridItem>

  );
}
